var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineChart = function SvgLineChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m17.938 3.777-4.054 5.529-2.962-1.616-3.181 6.072-2.335-2.388-2.035 5.55-1.408-.516 2.853-7.783 2.554 2.612 2.93-5.594 3.15 1.718 3.279-4.471 1.21.887Z",
    clipRule: "evenodd"
  })));
};
export { SvgLineChart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0xNy45MzggMy43NzctNC4wNTQgNS41MjktMi45NjItMS42MTYtMy4xODEgNi4wNzItMi4zMzUtMi4zODgtMi4wMzUgNS41NS0xLjQwOC0uNTE2IDIuODUzLTcuNzgzIDIuNTU0IDIuNjEyIDIuOTMtNS41OTQgMy4xNSAxLjcxOCAzLjI3OS00LjQ3MSAxLjIxLjg4N1oiIC8+PC9zdmc+";